import React, { useEffect, useState } from "react";
import CardList from "../CardList";
import NoData from "../NoData";
import moment from "moment";
import {
  getDates,
  getDayName,
  dateFormat,
  capitalize,
  getWeek,
} from "../../../utils/utilities";
import { renderIcons } from "../MonthPage";
import "./style.scss";

const WeekPage = (p) => {
  const {
    activeNav,
    activeDay,
    setActiveDay,
    listAllDataWeekly,
    listEventsWeekly,
    listAppointmentsWeekly,
    listGreetingsWeekly,
    flexibleDate,
    activeWeek,
    setActiveWeek,
    activePage,
    monthNow,
    activeMonth,
  } = p;
  const [fullDate, setFullDate] = useState([]);
  const dateNow = dateFormat(moment().toDate());
  const listWeekly =
    activeNav === 0
      ? listAllDataWeekly
      : activeNav === 1
      ? listEventsWeekly
      : activeNav === 2
      ? listAppointmentsWeekly
      : listGreetingsWeekly;

  const getDateOfThisMonth = () => {
    let date = moment(new Date(flexibleDate)).toDate();
    let first = moment(
      new Date(date.getFullYear(), date.getMonth(), 1)
    ).toDate();
    let last = moment(
      new Date(date.getFullYear(), date.getMonth() + 1, 0)
    ).toDate();
    let startDate = dateFormat(first);
    let lastDate = dateFormat(last);
    let fullDateRange = getDates(startDate, lastDate);
    setFullDate(fullDateRange);
  };

  const handleClickDate = (data) => {
    let week = getWeek(dateFormat(data));
    setActiveDay(data);
    if (week !== activeWeek) {
      setActiveWeek(week);
    }
  };

  useEffect(() => {
    getDateOfThisMonth();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      getScrollPosition();
    }, 500);
  }, [activePage]);

  const getScrollPosition = () => {
    if (activeMonth + 1 == monthNow + 1) {
      let date = moment(dateNow).format("D");
      let scrollLong = 0;
      if (date !== 1) {
        scrollLong = 47 * (date - 1);
      }
      document.getElementById("scroll").scrollLeft += scrollLong;
    }
  };

  return (
    <div className="week-page">
      <div id="scroll" className="week-scroll-nav">
        {fullDate.map((data, idx) => (
          <div
            className={`day-list ${dateNow === data ? "now " : ""} ${
              activeDay === data ? "active-day" : ""
            }`}
            key={idx}
            onClick={() => handleClickDate(data)}
          >
            <div>{getDayName(data)}</div>
            <div>{moment(data).format("D")}</div>
          </div>
        ))}
      </div>
      {listWeekly.length > 0 ? (
        listWeekly.map((data, idx) => (
          <div className="content-body" key={idx}>
            <CardList
              title={
                data.type === "Birthday"
                  ? `${data.user_first_name} ${data.user_last_name}'s Birthday`
                  : data.name
              }
              time={
                data.type === "Birthday"
                  ? "All Day"
                  : `${moment(data.start).format("HH:mm")} - ${moment(
                      data.end
                    ).format("HH:mm")}`
              }
              icons={renderIcons(data.type)}
              date={`${moment(data.start).format("D")} ${capitalize(
                getDayName(data.start)
              )}`}
            />
          </div>
        ))
      ) : (
        <NoData {...p} />
      )}
    </div>
  );
};

export default WeekPage;
